module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-chapter"
  }, [(!_vm.course) ? _c('div', [_vm._v("\n    " + _vm._s(_vm.$t("chapter.chapter-course-by-types.text")) + "\n    "), _c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.course) ? _c('div', {
    staticClass: "chapter-course"
  }, _vm._l((Object.keys(_vm.normalizeItems())), function(type) {
    return _c('div', {
      staticClass: "collapsed",
      style: ({
        height: _vm.calculateHeight(type)
      })
    }, [_c('div', {
      staticClass: "lesson-type",
      on: {
        "click": function($event) {
          return _vm.pickType(type)
        }
      }
    }, [_c('div', [_c('div', [_vm._v(_vm._s(_vm.types[type]))])]), _vm._v(" "), _c('div', {
      staticClass: "lesson-icon"
    }, [_c('inline-svg', {
      staticClass: "check-svg",
      attrs: {
        "src": _vm.imgTypes[type]
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "arrow"
    }, [_c('img', {
      attrs: {
        "src": _vm.Arrow,
        "alt": ""
      }
    })])]), _vm._v(" "), _vm._l((_vm.normalizeItems()[type]), function(lesson) {
      return _c('div', {
        staticClass: "lessons",
        on: {
          "click": function($event) {
            return _vm.goTo(lesson)
          }
        }
      }, [_vm._v("\n        " + _vm._s(lesson.name) + "\n\n        "), _c('div', {
        staticClass: "lesson-icon"
      }, [_c('inline-svg', {
        staticClass: "check-svg",
        attrs: {
          "src": _vm.imgTypes[type]
        }
      })], 1)])
    })], 2)
  }), 0) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10475cc7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter/chapter-course-by-types.vue
// module id = 550
// module chunks = 0